<img *ngIf="path && file_id"
     (click)="openDialog()"
     [src]="path + 'media/' + file_id + '/show'" height="128px"
     style="cursor: pointer"
/>
